import { useMemo, useState } from 'react';
import { withNamespaces } from 'react-i18next';
import { Input } from 'reactstrap';

import DateUtils from 'src/services/utils/DateUtils';
import { INTERNATIONAL_DATE_FORMAT } from 'src/common/constants';

const dateUtils = new DateUtils();

const ReportsList = ({
    onSelect,
    reports,
    selectedReportId,
    t,
}) => {
    const [search, setSearch] = useState('');
    const visibleReports = useMemo(() => {
        const query = search.trim().toLowerCase();

        if (!query) return reports;

        return reports.filter((report) => (
            [report.companyName, report.provider, report.dataset]
                .join(' ')
                .toLowerCase()
                .includes(query)
        ));
    }, [reports, search]);

    return (
        <div className="company-reports-list">
            <div className="d-flex align-items-center justify-content-between mb-3">
                <h5 className="mb-0">
                    {t('Reports')}
                    <span className="badge badge-soft-secondary ms-2">{reports.length}</span>
                </h5>
            </div>

            <Input
                className="mb-3"
                onChange={(event) => setSearch(event.target.value)}
                placeholder={t('Search company or provider...')}
                type="search"
                value={search}
            />

            {visibleReports.map((report) => (
                <button
                    className={`company-report-item ${selectedReportId === report.id ? 'is-active' : ''}`}
                    key={report.id}
                    onClick={() => onSelect(report.id)}
                    type="button"
                >
                    <span className="avatar-xs me-2">
                        <span className="avatar-title rounded bg-light text-primary">
                            <i className={report.providerIcon} />
                        </span>
                    </span>
                    <span className="flex-grow-1 text-start">
                        <span className="d-block fw-medium">{report.companyName}</span>
                        <span className="d-block text-muted font-size-12">{report.provider}</span>
                        <span className="d-block text-muted font-size-12">
                            {dateUtils.convertDateToDate(report.fetchedOn, INTERNATIONAL_DATE_FORMAT)}
                        </span>
                    </span>
                    <i className="ri-arrow-right-s-line text-muted" />
                </button>
            ))}

            {!visibleReports.length && (
                <p className="text-muted text-center mb-0">{t('No reports found.')}</p>
            )}
        </div>
    );
};

export default withNamespaces()(ReportsList);
